import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  token: '',
  indexText: {
    //--首页
    inTitle1: {
      ch: '关于我们',
      en: 'About us'
    },
    text1: {
      ch: '以知识产权为核心业务的平台化机构',
      en: 'A Platformization Organization with Intellectual Property as Core Business'
    },
    text2: {
      ch: '为国内外客户提供全方位、多层次、一站式的法律服务',
      en: 'We are committed to providing all-round, multi-level and one-stop legal services for domestic and foreign customers. '
    },
    text3: {
      ch: '艺识代知识产权以北京艺识代律师事务所为依托，辅以知识产权数据、咨讯、评估、学术等诸多专业机构与资源支持，以北京市经济技术开发区为区位依托，旨在为科技、文创等领域的广大客户提供“一站式、全方位”知识产权服务，即为客户提供多门类（涉及专利、商标、著作权、商业秘密等）；多流程（涉及登记、申请、复审、行政诉讼、维权诉讼、代为管理等）；多境域（立足国内与国际协作）专业服务。',
      en: 'Beijing easytimes Intellectual Property Service Center Co., Ltd. (hereinafter referred to as "easytimes intellectual property") was established in July 2015 to establish a "easytimes intellectual property service center" based on Beijing Economic and Technological Development Zone to provide "on'
    },
    text4: {
      ch: '了解更多',
      en: 'Learn More'
    },
    //--托管业务
    inTitle2: {
      ch: '代管业务',
      en: 'Escrow Service'
    },
    intg1: {
      title: {
        ch: '信息化水平高',
        en: 'High informatization level'
      },
      cat: {
        ch: '我们专门开发了专用信息管理系统，<br/>可以高效与客户进行交互与信息共享。',
        en: 'We have specially developed a special information management system, which can efficiently interact and share information with customers.'
      }
    },
    intg2: {
      title: {
        ch: '专业水平高',
        en: 'High Professional Level'
      },
      cat: {
        ch: '根据客户需求，设立和调配专业团队，<br/>没有具体专业限制，也不受负责人员流动影响。',
        en: 'Set up and deploy professional teams according to customer‘s requirements.There are no specific professional restrictions, and it is not affected by the turnover of responsible personnel.'
      }
    },
    intg3: {
      title: {
        ch: '一站式知识产权综合服务平台',
        en: 'One-stop Comprehensive Intellectual Property Service Platform with Intellectual Property as Core Business'
      },
      cat: {
        ch: '以知识产权为核心业务',
        en: 'Intellectual property as the core business'
      }
    },
    intg4: {
      title: {
        ch: '费用合理优惠',
        en: 'Reasonable and Preferential Fees'
      },
      cat: {
        ch: '采用会员制管家服务，普通会员每年仅收费3650元；免费向会员提供咨询服务，免费为客户建档；部分专项如商标申请，著作权登记，代缴费等可以先服务后收费，其他专项服务按照约定标准收费。',
        en: 'We offer a membership butler service, only RMB 3650 yuan per year for ordinary members. We provide free consulting and documentation services to our members. Some special services can be served first and then charged, such as trademark application, copyright registration, payment on behalf of others. Other special services shall be charged according to the agreed standard.'
      }
    },
    //--专项业务
    inTitle3: {
      ch: '专项业务',
      en: 'PRACTICES',
      list: [
        {
          ch: '科创板公司知识产权专项服务',
          en: 'Special intellectual property services for  enterprises listed on Science and Technology Innovation Board',
          layerShow_ch:'当客户的专利权、商标权、著作权、域名、商业秘密等知识产权遭受侵害时，为客户提供各种维权服务代理与中介，包括但不限于民事起诉、行政查处、电商平台投诉、刑事报案等。',
          layerShow_en:'',
        },
        {
          ch: '投资中知识产权尽职调查与评估',
          en: 'Due diligence and evaluation of intellectual property in investment',
          layerShow_ch:'为客户在境内外提供商标申请代理/中介；专利申请代理与中介（含PCT）；著作权登记代理与申请。',
          layerShow_en:'',
        }, {
          ch: '知识产权布局与保护',
          en: 'Layout and protection of intellectual property rights',
          layerShow_ch:'近年来，科创板拟上市公司屡屡因为知识产权问题被中断上市，我们可以为科创板拟上市公司提供知识产权优化服务，包括但不限于优化知识产权保护体系、知识产权侵权风险评估与规避、核心专利稳定性评估等。',
          layerShow_en:'',
        }, {
          ch: '知识产权维权',
          en: 'Intellectual property rights protection',
          layerShow_ch:'近年来，投资项目由传统资源类项目逐渐向技术类项目转变，特别是“卡脖子”技术项目和进口替代性项目，需要对目标项目涉及的知识产权进行尽调和风险评估，必要时还需要对项目竞品涉及的知识产权进行尽职调查与风险评估。我们可以接受投资方委托，对目标项目涉及的知识产权提供上述服务。',
          layerShow_en:'',
        }, {
          ch: '知识产权融资与变现',
          en: 'Intellectual property financing and Realization',
          layerShow_ch:'对于客户的新技术研发成果和新商业模式，提供全方位知识产权保护体系，包括但不限于专利发明点挖掘与整理、技术成果查新与评估、保密体系建立与完善、竞争对手知识产权状况分析、商标布局等。',
          layerShow_en:'',
        }, {
          ch: '商标注册/专利申请/著作权登记',
          en: 'Trademark registration / patent application / copyright registration',
          layerShow_ch:'知识产权不仅可以用来保护市场，本身也具有显著的财产性，可以直接或者间接地实现融资和变现。我们可以帮助客户实现各类知识产权融资与变现，包括但不限于知识产权转让与使用许可；知识产权抵押贷款；知识产权入股；知识产权证券化等。',
          layerShow_en:'',
        }, {
          ch: '知识产权贯标辅导',
          en: 'Guidance on implementation of intellectual property standards',
          layerShow_ch:'企业知识产权贯标的“标”指我国2013年3月1日正式实施的GB/T 29490‐2013《企业知识产权管理规范》。“知识产权贯标”对于企业来说，就是贯彻《企业知识产权管理规范》国家标准，获得国家认证，颁发知识产权贯标证书。通过“贯标”，企业可以大大提高知识产权管理与运用水平。我们可以为企业符合贯标要求提供辅导服务，使之符合国家认证标准。',
          layerShow_en:'',
        }, {
          ch: '其他知识产权专项服务',
          en: 'Other intellectual property special services',
          layerShow_ch:'作为“一站式、全方位”知识产权服务平台，我们可以提供客户定制化的其他知识产权服务，包括但不限于知识产权培训，知识产权检索与数据服务，知识产权专项咨询，知识产权采购等等。',
          layerShow_en:'',
        },
      ]
    },
    lookMore: {
      ch: '',
      en: ''
    },
    //--最新资讯
    inTitle4: {
      ch: '最新资讯',
      en: 'NEWS',
      nav: [
        {
          ch: '主要活动',
          en: 'Main activities'
        },
        {
          ch: '重大行业资讯',
          en: 'Major industry information'
        },
        {
          ch: '最新立法/案例',
          en: 'Latest legislation / cases'
        },
      ],
      list: [
        {
          date: {
            y: '2021',
            me: '09/02'
          },
          title: {
            ch: '以知识产权为核心业务的平台化机构',
            en: 'Platform organization with intellectual property as its core business'
          },
          img: require('../assets/images/news_img.png'),
          cnt: {
            ch: '成立于1988年，紧随我国专利制度的实施而诞生，是我国早期得到批准成立的专利事务所之一，致力于在知识产权领域为公众及企业界提供法律与技术支持...',
            en: `Founded in 1988, it was born following the implementation of China's patent system. It is one of the early approved patent firms in China. It is committed to providing legal and technical support for the public and business circles in the field of intellectual property rights`
          },
          detl: {
            ch: '查看详情',
            en: 'View Details'
          }
        },
        {
          date: {
            y: '2021',
            me: '09/02'
          },
          title: {
            ch: '以知识产权为核心业务的平台化机构',
            en: 'Platform organization with intellectual property as its core business'
          },
          img: '',
          cnt: {
            ch: '成立于1988年，紧随我国专利制度的实施而诞生，是我国早期得到批准成立的专利事务所之一，致力于在知识产权领域为公众及企业界提供法律与技术支持...',
            en: `Founded in 1988, it was born following the implementation of China's patent system. It is one of the early approved patent firms in China. It is committed to providing legal and technical support for the public and business circles in the field of intellectual property rights`
          },
          detl: {
            ch: '查看详情',
            en: 'View Details'
          }
        }, {
          date: {
            y: '2021',
            me: '09/02'
          },
          title: {
            ch: '以知识产权为核心业务的平台化机构',
            en: 'Platform organization with intellectual property as its core business'
          },
          img: '',
          cnt: {
            ch: '成立于1988年，紧随我国专利制度的实施而诞生，是我国早期得到批准成立的专利事务所之一，致力于在知识产权领域为公众及企业界提供法律与技术支持...',
            en: `Founded in 1988, it was born following the implementation of China's patent system. It is one of the early approved patent firms in China. It is committed to providing legal and technical support for the public and business circles in the field of intellectual property rights`
          },
          detl: {
            ch: '查看详情',
            en: 'View Details'
          }
        }, {
          date: {
            y: '2021',
            me: '09/02'
          },
          title: {
            ch: '以知识产权为核心业务的平台化机构',
            en: 'Platform organization with intellectual property as its core business'
          },
          img: '',
          cnt: {
            ch: '成立于1988年，紧随我国专利制度的实施而诞生，是我国早期得到批准成立的专利事务所之一，致力于在知识产权领域为公众及企业界提供法律与技术支持...',
            en: `Founded in 1988, it was born following the implementation of China's patent system. It is one of the early approved patent firms in China. It is committed to providing legal and technical support for the public and business circles in the field of intellectual property rights`
          },
          detl: {
            ch: '查看详情',
            en: 'View Details'
          }
        }, {
          date: {
            y: '2021',
            me: '09/02'
          },
          title: {
            ch: '以知识产权为核心业务的平台化机构',
            en: 'Platform organization with intellectual property as its core business'
          },
          img: '',
          cnt: {
            ch: '成立于1988年，紧随我国专利制度的实施而诞生，是我国早期得到批准成立的专利事务所之一，致力于在知识产权领域为公众及企业界提供法律与技术支持...',
            en: `Founded in 1988, it was born following the implementation of China's patent system. It is one of the early approved patent firms in China. It is committed to providing legal and technical support for the public and business circles in the field of intellectual property rights`
          },
          detl: {
            ch: '查看详情',
            en: 'View Details'
          }
        }, {
          date: {
            y: '2021',
            me: '09/02'
          },
          title: {
            ch: '以知识产权为核心业务的平台化机构',
            en: 'Platform organization with intellectual property as its core business'
          },
          img: '',
          cnt: {
            ch: '成立于1988年，紧随我国专利制度的实施而诞生，是我国早期得到批准成立的专利事务所之一，致力于在知识产权领域为公众及企业界提供法律与技术支持...',
            en: `Founded in 1988, it was born following the implementation of China's patent system. It is one of the early approved patent firms in China. It is committed to providing legal and technical support for the public and business circles in the field of intellectual property rights`
          },
          detl: {
            ch: '查看详情',
            en: 'View Details'
          }
        },
      ]
    },
    lookMore: {
      ch: '查看更多',
      en: 'View All'
    },
    footer: {
      txt: {
        ch: '艺识代知识产权：一站式知识产权综合服务平台',
        en: 'EasyTimes IP: One-stop Comprehensive Intellectual Property Service Platform'
      },
      htw: 'www.easytimesip.com',
      eml: {
        ch: '咨询邮箱：',
        en: 'Email:'
      },
      adrs: {
        ch: '公司地址：',
        en: 'Company address：'
      },
      adrc: {
        ch: '北京市北京经济开发区荣华中路19号路朝林广场A-1602（100176）',
        en: 'A-1602, Zhaolin Plaza, No.19 Ronghua Middle Road, Economic-Technological Development Area, Beijing 100176'
      },
      tel: {
        ch: '咨询电话：',
        en: 'Tel.:'
      },
      telnum:{
        ch:'（010）67814266',
        en:' 86 – 10 – 6781 4266'
      },
      bnun: {
        ch: '京公网安备 11030102011487号',
        en: '京公网安备 11030102011487号'
      }
    }
  }
}

const store = new Vuex.Store({
  state
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js